export const spacingMap: Record<string, string> = {

  quad : '~',
  qquad: '~~',
  space: ' ',
  ',':'`',
  '\\':'#',
};